<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
@if(choice().maxIngredients === 1 && this.choice().enforcedIngredients === 1){
    <label class="ingredient-name">
      <span aria-hidden="true">{{ingredient().name}}</span><div class="checkbox-wrapper">
        @if(configService.configState().store?.showIngredientPricesOnOrder && displayedPrice()){
        <span class="price">+${{displayedPrice()?.toFixed(2)}}</span>
        }
        <input [style.display]="loading ? 'none' : undefined" class="themed-radio" type="radio" [checked]="initialValue"
          (change)="toggleIngredient(initialValue, inputElement)" #inputElement [name]="choice().name"
          [attr.aria-label]="ingredient().name + (displayedPrice() ? ' +$' + displayedPrice()?.toFixed(2) : '')"
          [attr.aria-checked]="initialValue">
        @if(loading){
        <div class="loading-radio"></div>
        }
      </div>
    </label>
    }
    @if(!(choice().maxIngredients === 1 && this.choice().enforcedIngredients === 1)){
    @if(ingredient().allowHalves || ingredient().qualifiers.length > 0) {  
    <div class="tooltip-container">
      <cwo-tooltip
        *transloco="let t"
        [visible]="initialValue && ingredient().isExtraIngredientUpsell && !orderableItem().isExtraIngredientTooltipOpenedOnce"
        [placement]="[tooltipPlacement.TopEnd, tooltipPlacement.BottomEnd]"
        [triggers]="'click'"
        [autoClose]="false"
        [offsetY]="16"
        [offsetX]="9"
        [arrowPadding]="275"
        [customTopPadding]="tooltipTopMargin() + 60"
        [customeBottomPadding]="initialValue ? -55 : 16"
        (tooltipClosed)="toggleTooltip(false)"
        [openTooltip]="openTooltip"
        [closeAllTooltips]="closeAllTooltips"
      >
        <cwo-expandable-component
          class="expandable"
          [expandedInput]="initialValue"
          [useNonButtonHeader]="true"
          [ariaControlsName]="'Select to expand ' + ingredient().name + 'for more details'"
        >
          <ng-template #heading>
            <label
              class="ingredient-name"
              role="checkbox"
              (click)="inputElement.toggleCheckbox($event)"
              (keydown.space)="inputElement.toggleCheckbox($event); toggleTooltip(true)"
              (keydown.enter)="inputElement.toggleCheckbox($event); toggleTooltip(true)"
              tabindex="0"
              [attr.aria-checked]="initialValue"
              [attr.aria-label]="ingredient().name + (displayedPrice() ? ', +$' + displayedPrice()?.toFixed(2) : '')"
            >
              <span tabindex="-1" aria-hidden="true">{{ingredient().name}}</span>
              <div
                class="checkbox-wrapper"
                aria-hidden="true"
              >
                @if(configService.configState().store?.showIngredientPricesOnOrder && displayedPrice()){
                <span class="price">{{'+'}}{{displayedPrice()?.toFixed(2) | currency: 'USD'}}</span>
                }
                <cwo-custom-checkbox
                  #inputElement
                  [(ngModel)]="initialValue" 
                  (ngModelChange)="toggleIngredient($event, inputElement)" 
                  [loading]="loading"
                  [ariaLabel]="ingredient().name"
                  [inputTabIndex]="-1"
                  [useStopPropagation]="false">
                </cwo-custom-checkbox>
              </div>
            </label>
          </ng-template>
          <ng-template #content>
            <div class="expandable-content" #expandableContent>
              @if (ingredient().allowHalves) {
              <div class="half-row">
                <cwo-side-selection [orderedIngredient]="orderedIngredient" [(ngModel)]="selectedSide" (ngModelChange)="sideSelection($event)" [radioGroupName]="index() + ingredient().name"/>
                @if (ingredient().qualifiers.length > 0) {
                <cwo-qualifier [displayStyle]="qualifierDisplayStyle()" [selectedQualifiers]="orderedIngredient?.qualifiers ?? []"
                  [qualifiers]="ingredient().qualifiers" [isQualifierSelected]="initialValue" (qualifierChange)="toggleQualifier($event)"
                  />
                }
              </div>
              } @else if (ingredient().qualifiers.length > 0) {
                <cwo-qualifier [displayStyle]="qualifierDisplayStyle()" [selectedQualifiers]="orderedIngredient?.qualifiers ?? []"
                  [qualifiers]="ingredient().qualifiers" [isQualifierSelected]="initialValue" (qualifierChange)="toggleQualifier($event)"
                  />
              }
              @if (choice().allowSecondHalves && selectedSide !== sideSelectionType.WHOLE) {
              <div class="half-row">
                <cwo-side-selection [orderedIngredient]="orderedIngredient" [(ngModel)]="selectedSecondSide" (ngModelChange)="secondSideSelection($event)" [radioGroupName]="index() + ingredient().name + '-second'" [allowDeselect]="true" [disableWhole]="true" [disableLeft]="selectedSide === sideSelectionType.LEFT" [disableRight]="selectedSide === sideSelectionType.RIGHT" />
                @if (ingredient().qualifiers.length > 0) {
                <cwo-qualifier [displayStyle]="qualifierDisplayStyle()" [selectedQualifiers]="selectedSecondHalfQualifiers"
                  [qualifiers]="ingredient().qualifiers" [isQualifierSelected]="initialValue" (qualifierChange)="toggleSecondHalfQualifier($event)"
                  />
                }
              </div>
              }
            </div>
          </ng-template>
        </cwo-expandable-component>
        <ng-template #tooltipTemplate>
          <div style="overflow: visible;" class="tooltip-wrapper">
            <span class="tooltip-content">
              <b>{{t('shared_components.choices.ingredients.extra')}}</b>{{t('shared_components.choices.ingredients.for_only_more', {name: ingredient().name, price: priceForExtra().toFixed(2)})}}
              </span>

            <div class="buttons-container">
              <button class="button-accent button-white button-custom" (click)="onTooltipClose(true)">
                {{ t('shared_components.choices.ingredients.tooltip.add_it') }}
              </button>
              <button class="button-accent button-white-outlined button-custom" (click)="onTooltipClose()">
                {{ t('shared_components.choices.ingredients.tooltip.no_thanks') }}
              </button>
            </div>
          </div>
        </ng-template>
      </cwo-tooltip>
    </div>
    } @else {
    <label class="ingredient-name" role="checkbox" (click)="inputElement.toggleCheckbox($event)"
    (keydown.space)="inputElement.toggleCheckbox($event)"
    (keydown.enter)="inputElement.toggleCheckbox($event)" tabindex="0"
    [attr.aria-checked]="initialValue"
    [attr.aria-label]="ingredient().name + (displayedPrice() ? ', +$' + displayedPrice()?.toFixed(2) : '')">
      <span tabindex="-1" aria-hidden="true">{{ingredient().name}}</span>
      <div class="checkbox-wrapper" aria-hidden="true">
        @if(configService.configState().store?.showIngredientPricesOnOrder && displayedPrice()){
        <span class="price">+${{displayedPrice()?.toFixed(2)}}</span>
        }
        <cwo-custom-checkbox 
          #inputElement
          [ariaLabel]="ingredient().name"
          [(ngModel)]="initialValue" 
          [inputTabIndex]="-1"
          (ngModelChange)="toggleIngredient($event, inputElement)" 
          [loading]="loading">
        </cwo-custom-checkbox>
      </div>
    </label>
    }
    }
    
    @if(initialValue && ingredientDependableChoices().length > 0){
      <div class="dependable-choices-wrapper">
        @for(dependableChoice of ingredientDependableChoices(); track $index) {
          <cwo-dependable-choice class="choice" [isSpecial]="isSpecial()" [expandedInput]="$index === 0" [choice]="dependableChoice"
            [orderedChoice]="orderedItem().getChoice(dependableChoice.name)" [orderedItem]="orderedItem()"
            [orderableItem]="orderableItem()"
            (updateSpecialItem)="updatedSpecialItem.emit($event)" />
        }
      </div>
    }

    <ng-template #tooltipContent>
      <span class="tooltip-content" *transloco="let t">
        <b>{{t('shared_components.choices.ingredients.extra')}}</b>{{t('shared_components.choices.ingredients.for_only_more', {name: ingredient().name, price: priceForExtra().toFixed(2)})}}
        </span>
    </ng-template>